export const currency = value => {
  if (!value) return '0.00'
  let formatted = parseFloat(value).toFixed(2)
  if (formatted > 999) {
    formatted = formatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  return formatted
}
